var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "brb-btn",
    {
      staticClass: "p-0 m-0",
      attrs: {
        href: _vm.src ? _vm.$config.files.createStaticUrl(_vm.src) : "#",
        target: "_blank",
        variant: "link",
      },
    },
    [
      _c(
        "brb-media",
        _vm._b(
          {
            class: [
              { "img-thumbnail": !_vm.noThumbnail },
              { "img-circle": _vm.circle },
              _vm.thumbnailClass,
            ],
            style: _vm.thumbnailStyle,
            attrs: { src: _vm.src, width: _vm.width, height: _vm.height },
          },
          "brb-media",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }